// Keys typed into a field (the generator's prompt, a copyable wanted list)
// belong to that field, not to the shelf or the booklet.
export function typing(e: KeyboardEvent) {
  const el = e.target
  return (
    el instanceof HTMLElement &&
    (el.isContentEditable || !!el.closest('input, textarea, select'))
  )
}
